import { render, staticRenderFns } from "./ContactSupport.vue?vue&type=template&id=5125ca6f&scoped=true&"
import script from "./ContactSupport.vue?vue&type=script&lang=js&"
export * from "./ContactSupport.vue?vue&type=script&lang=js&"
import style0 from "./ContactSupport.vue?vue&type=style&index=0&id=5125ca6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5125ca6f",
  null
  
)

export default component.exports